import { IContentSource } from "./IContentSource";

export class ContentSource implements IContentSource {
  constructor(public url: string) {
  }

  public get source(): string {
    return this.url;
  }

  public clone(): IContentSource {
    return new ContentSource(
      this.url
    );
  }
}
